import React, {Component} from 'react';


class LoadingContainerCorrect extends Component {
    constructor(props) {
        super(props)
        
        this.state = {
            text : ''
        }
    }
    componentDidMount() {
        let texts = [
            "Loading DBQs, please wait approx. 15 seconds while the changes are highlighted",
            "Loading DBQs, please wait approx. 15 seconds while the changes are highlighted",
            "Loading DBQs, please wait approx. 15 seconds while the changes are highlighted .",
            "Loading DBQs, please wait approx. 15 seconds while the changes are highlighted ..",
            "Loading DBQs, please wait approx. 15 seconds while the changes are highlighted ..."];
        let index = 0;
        this.setState({text : texts[index]})
                this.interval = setInterval(() => {
                    this.setState({ text: texts[++index] })
                    if (index === texts.length-1) {
                        index = 0
                    }
                }, 500);
      }
      componentWillUnmount() {
        clearInterval(this.interval);
      }
    render() {
        return (
           
            <h3 style={{color: "#022144", fontSize: 18}}>{this.state.text}</h3>
            
        );
    }
}

export default LoadingContainerCorrect